
import React from 'react';
import styles from './PropertyCardSearch.scss';
import AgentAvatar from '../AgentAvatar/AgentAvatar';

export const AgentCardSmall = (props) => {
  const agency = props.agency;
  const agent = agency?.agents?.[0];
  const avatarUrl = '/assets/images/profile_icon.svg';

  return (
    <div className="d-flex w-100 justify-content-center">
      <div className="my-auto"><AgentAvatar size="xs" avatarUrl={agent?.headShot || avatarUrl}/></div>
      <div className={'pl-2 flex-grow-1 my-auto ' + styles.agentRep}>
        <div className="bold500">{agent?.name || 'Agent name not disclosed'}</div>
        <div className={styles.agencyName}>{agency?.name || 'Agency name not disclosed'}</div>
      </div>
      {!!agency?.logo && <div className={'text-right my-auto ' + styles.agentLogo}><img src={agency.logo} width="300" alt={agency?.name} /></div>}
    </div>
  );
};
